import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Solution() {
  const solutions = [
    { icon: 'ri-search-eye-line', title: 'Diagnóstico Técnico Completo', description: 'Análise profunda dos seus riscos, coberturas atuais e oportunidades de economia.', benefit: 'Identifique brechas antes que virem prejuízo' },
    { icon: 'ri-hand-coin-line', title: 'Negociação Estratégica', description: 'Usamos nosso poder de compra e relacionamento com seguradoras para reduzir seus custos.', benefit: 'Economia média de 35% nos prêmios' },
    { icon: 'ri-shield-check-line', title: 'Gestão Profissional', description: 'Acompanhamento contínuo, renovações estratégicas e suporte em sinistros.', benefit: 'Proteção garantida sem preocupação' },
    { icon: 'ri-line-chart-line', title: 'Otimização Contínua', description: 'Revisão periódica para garantir que você sempre tenha o melhor custo-benefício.', benefit: 'Seu seguro evolui com seu negócio' }
  ];

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggerAnimation(solutions.length);
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section id="solucao" className="py-16 sm:py-20 lg:py-28 bg-white" aria-labelledby="solution-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex items-center gap-2 bg-strategic-green-100 px-4 py-2 rounded-full mb-4 sm:mb-6" aria-hidden="true">
            <i className="ri-lightbulb-flash-line text-strategic-green-700 text-base sm:text-lg"></i>
            <span className="text-strategic-green-800 font-bold text-xs sm:text-sm uppercase tracking-wide">A Solução</span>
          </div>
          <h2 id="solution-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Como a IBX Brasil{' '}
            <span className="text-strategic-green-600">Transforma</span>{' '}
            Sua Gestão de Seguros
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-petrol-800 max-w-3xl mx-auto leading-relaxed px-4">
            Aplicamos metodologia profissional de gestão de riscos e contratação de seguros para <strong className="text-petrol-900">proteger seu patrimônio</strong> e <strong className="text-petrol-900">reduzir custos significativamente</strong>.
          </p>
        </div>

        <div ref={gridRef as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {solutions.map((solution, index) => (
            <article
              key={index}
              className={`bg-gradient-to-br from-petrol-50 to-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl border border-petrol-100 hover:border-strategic-green-400 group transition-all duration-700 ease-out ${visibleItems[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-strategic-green-500 to-strategic-green-600 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform" aria-hidden="true">
                <i className={`${solution.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-petrol-900 mb-3 sm:mb-4">{solution.title}</h3>
              <p className="text-sm sm:text-base text-petrol-800 leading-relaxed mb-3 sm:mb-4">{solution.description}</p>
              <div className="flex items-start gap-2 bg-strategic-green-50 rounded-lg p-3 sm:p-4 border-l-4 border-strategic-green-500">
                <i className="ri-checkbox-circle-fill text-strategic-green-700 text-base sm:text-lg mt-0.5 flex-shrink-0" aria-hidden="true"></i>
                <span className="text-xs sm:text-sm font-semibold text-strategic-green-900">{solution.benefit}</span>
              </div>
            </article>
          ))}
        </div>

        <div
          ref={ctaRef as React.RefObject<HTMLDivElement>}
          className={`bg-gradient-to-r from-petrol-900 to-petrol-700 rounded-xl sm:rounded-2xl p-6 sm:p-10 lg:p-12 text-center shadow-2xl transition-all duration-700 ease-out ${ctaVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'}`}
        >
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 px-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Pronto Para Economizar e Proteger Melhor?
          </h3>
          <p className="text-base sm:text-lg lg:text-xl text-gray-100 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Solicite uma análise gratuita e descubra quanto você pode economizar com gestão profissional de seguros.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center px-4">
            <a
              href="https://wa.me/5577988080505?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20an%C3%A1lise%20gratuita."
              target="_blank"
              rel="nofollow noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 bg-strategic-green-500 text-white px-6 sm:px-8 py-4 sm:py-5 rounded-xl text-base sm:text-lg font-bold hover:bg-strategic-green-600 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
              aria-label="Solicitar análise gratuita via WhatsApp"
            >
              <i className="ri-whatsapp-line text-xl sm:text-2xl" aria-hidden="true"></i>
              Solicitar Análise Gratuita
            </a>
            <a
              href="#como-funciona"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 bg-white text-petrol-900 px-6 sm:px-8 py-4 sm:py-5 rounded-xl text-base sm:text-lg font-bold hover:bg-gray-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
              aria-label="Ver como funciona a IBX Brasil"
            >
              <i className="ri-play-circle-line text-xl sm:text-2xl" aria-hidden="true"></i>
              Ver Como Funciona
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
